import { render } from "./UserError.vue?vue&type=template&id=34e0a0ad&scoped=true&ts=true"
import script from "./UserError.vue?vue&type=script&lang=ts"
export * from "./UserError.vue?vue&type=script&lang=ts"

import "./UserError.vue?vue&type=style&index=0&id=34e0a0ad&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\mobileApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34e0a0ad"]])

export default __exports__